import { VALIDATION_STATES } from '../../../core/const/fields.js';

export default {
  props: {
    fieldId: {
      type: String,
    },
    placeholder: {
      type: String,
      required: true,
    },
    validationState: {
      type: String,
      default: VALIDATION_STATES.unprocessed,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    exactMatch: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      required: true,
    },
    getSuggestions: {
      type: Function,
    },
    getFormattedItem: {
      type: Function,
    },
    defaultValue: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
    },
  },

  data() {
    return {
      isFocused: false,
      isOpen: false,
      suggestions: [],
      search: this.value ? this.value.label : '',
      internalValue: this.search,
      counter: 0,
      suggestionHeight: 0,
      suggestionsBoxHeight: 0,
      suggestionHeightWasCalculated: false,
    };
  },

  methods: {
    onFocus() {
      document.addEventListener('click', this.onClickOutside);
      this.isFocused = true;
      this.awaitSuggestions();
    },

    onTyping() {
      this.awaitSuggestions();
    },

    async awaitSuggestions() {
      this.suggestions = await this.getSuggestions(this.search);
      this.openResults();
    },

    openResults() {
      if (this.suggestions.length > 0) {
        this.isOpen = true;
        this.calculateSuggestionsBoxHeight();
        this.calculateSuggestionHeight();
      } else if (this.search.length > 0 || this.exactMatch === false) {
        this.hide();
      } else {
        this.close();
      }
    },

    calculateSuggestionsBoxHeight() {
      this.$nextTick(() => {
        this.suggestionsBoxHeight = this.$el.querySelector('ul').offsetHeight;
      });
    },

    calculateSuggestionHeight() {
      if (!this.suggestionHeightWasCalculated) {
        this.$nextTick(() => {
          this.suggestionHeight = this.$el.querySelector('li').offsetHeight;
          this.suggestionHeightWasCalculated = true;
        });
      }
    },

    onArrowNext() {
      if (this.counter < this.suggestions.length - 1) {
        this.counter += 1;
      }
      this.scroll();
    },

    onArrowPrev() {
      if (this.counter > 0) {
        this.counter -= 1;
      }
      this.scroll();
    },

    scroll() {
      const visibleItems = this.suggestionsBoxHeight / this.suggestionHeight;
      const listScrollTop = this.$refs.list.scrollTop;
      const scrolledItems = listScrollTop / this.suggestionHeight;
      const scrollDown = this.counter >= visibleItems - scrolledItems;
      const scrollUp = this.counter < scrolledItems;
      if (this.suggestions.length > visibleItems && (scrollDown || scrollUp)) {
        this.$refs.list.scrollTop = this.counter * this.suggestionHeight;
      }
    },

    resetSuggestionCalculation() {
      this.suggestionHeightWasCalculated = false;
    },

    onEnter() {
      this.pickOption(this.counter);
    },

    pickOption(index) {
      const item = this.suggestions[index];
      if (item) {
        const suggestion = (item.label) ? item.label : item;
        this.search = suggestion;
        this.select(index);
      } else {
        this.select();
      }
    },

    onEscape() {
      this.select();
    },

    onClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.select();
      }
    },

    select(index) {
      if (index !== undefined) {
        // if user selected an index it's one of the list
        // value will always be updated properly
        const suggestion = this.suggestions[index];
        this.internalValue = suggestion;
      } else if (this.exactMatch) {
        // if it's not a selection from the suggestions
        // then it's a free search text not matching anything
        // if we wanted an exact match, we keep it non valid
        this.internalValue = null;
      } else {
        // not a selection from the suggestions
        // but exact match not required, get the search term
        this.internalValue = {
          other: true,
          label: this.search,
          value: this.search,
        };
      }

      this.close();
    },

    close() {
      this.isFocused = false;
      this.hide();
      this.counter = 0;
      if (this.$refs.field) {
        this.$refs.field.blur();
      }
      this.onChange(this.internalValue);
      document.removeEventListener('click', this.onClickOutside);
    },

    hide() {
      this.isOpen = false;
    },
  },

  mounted() {
    document.addEventListener('resize', this.resetSuggestionCalculation);
  },

  destroyed() {
    document.removeEventListener('resize', this.resetSuggestionCalculation);
  },

  computed: {
    isValid() {
      return this.validationState === VALIDATION_STATES.valid;
    },
    hasError() {
      return this.validationState === VALIDATION_STATES.error;
    },
    hasContent() {
      if (this.search) {
        return !!this.search;
      }
      return false;
    },
    isActive() {
      return this.isFocused || this.hasContent;
    },
    labelMessage() {
      return this.hasError ? this.errorMessage : this.placeholder;
    },
  },
};
